import { RouteObject } from "react-router-dom";
import { billCorrectionRoutes } from "./bill-correction/routes";
import { bxBillCycleRoutes } from "./bill-cycle/routes";
import { billDetailRoutes } from "./bill-detail/routes";
import { billTemplateV2Routes } from "./billTemplateV2";
import { bulkBillGenerationRoutes } from "./bulk-bill-generation/routes";
import { bulkBillRoutes } from "./BulkBillGeneration/routes";
import { dashboardRoutes } from "./dashboard";
import { bxGlRouteRoute } from "./gl-code/routes";
import { bxHistoryRoutes } from "./history";
import { bxPrintingDistributionRoutes } from "./printing-distribution";
import { bxSearchRoutes } from "./search";
import { bxSingleBillGenarationRoutes } from "./singleBillGenaration";
import { billTemplateV3Routes } from "./billTemplateV3/route";
export interface BxRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: BxRoute[];
}
export const bxRoutes: BxRoute[] = [
  ...bulkBillGenerationRoutes,
  ...bxSingleBillGenarationRoutes,
  // ...bxBillTemplateRoutes,
  ...billTemplateV3Routes,
  ...bxSearchRoutes,
  ...dashboardRoutes,
  ...bxBillCycleRoutes,
  ...bxGlRouteRoute,
  ...bxPrintingDistributionRoutes,
  ...billTemplateV2Routes,
  ...bxHistoryRoutes,
  ...bulkBillRoutes,
  ...billCorrectionRoutes,
  ...billDetailRoutes,
];
